import { translate } from "@/app/support/utils";
import { NotificationAlertType } from "../interfaces/Components/alpinejs/NotificationAlert";

export interface NotificationConfig {
    message: {
        [key: string]: (data: object) => string;
    };
    alertType: {
        [key: string]: NotificationAlertType;
    };
}

export default {
    message: {
        'App\\Notifications\\Export\\EstimateExportSuccess': (data: object) => {
            const url = (data as ({ path: string })).path;

            return translate('The export has finished. You can download it :anchor_begin:by clicking here:anchor_finish:', {
                'anchor_begin:': '<a href="' + url + '" class="text-blue-500 underline">',
                'anchor_finish:': '</a>',
            });
        },
        'App\\Notifications\\Export\\EstimateExportFailed': () => {
            return translate('The export has failed. If this error persist, please contact an administrator');
        },
        'App\\Notifications\\Slip\\BpuUpdateWasSuccessfull': (data: object) => {
            const finalData = (data as ({
                createdItemCount: number,
                updatedItemCount: number,
                deletedItemCount: number,
            }));

            return translate('The Bpu update was successfull. :created items created, :updated items updated, :deleted items deleted', {
                created: finalData.createdItemCount.toString(),
                updated: finalData.updatedItemCount.toString(),
                deleted: finalData.deletedItemCount.toString(),
            });
        },
        'App\\Notifications\\Slip\\BpuUpdateHasFailed': () => {
            return translate('The Bpu update was a failure. Please contact an administrator');
        },
        'App\\Notifications\\Slip\\BpuPriceCoefficientApplyWasSuccessfull': (data: object) => {
            const finalData = (data as ({ coefficient: number }));

            return translate('We applied the price coefficient with factor :quantificator successfully', {
                quantificator: finalData.coefficient.toString(),
            });
        },
        'App\\Notifications\\Slip\\BpuPriceCoefficientApplyHasFailed': () => {
            return translate('The action to apply a coefficient was a failure. Please contact an administrator');
        },
        'App\\Notifications\\Statistic\\StatisticsGenerated': (data: object) => {
            // Retrieve url parameter
            const url = (data as ({ url: string })).url;

            // Message with url
            return translate('The statistics have been generated. You can :anchor_begin:view them here:anchor_finish:', {
                'anchor_begin:': '<a href="' + url + '" class="text-blue-500 underline">',
                'anchor_finish:': '</a>',
            });
        },
        'App\\Notifications\\Statistic\\StatisticsFailedToBeGenerated': () => {
            return translate('The statistics generation has failed. Please try again later');
        },

        default: () => {
            return translate('This notification type is not recognized. Please contact an administrator');
        },
    },
    alertType: {
        'App\\Notifications\\Export\\EstimateExportSuccess': 'success',
        'App\\Notifications\\Export\\EstimateExportFailed': 'danger',
        'App\\Notifications\\Slip\\BpuUpdateWasSuccessfull': 'success',
        'App\\Notifications\\Slip\\BpuUpdateHasFailed': 'danger',
        'App\\Notifications\\Slip\\BpuPriceCoefficientApplyWasSuccessfull': 'success',
        'App\\Notifications\\Slip\\BpuPriceCoefficientApplyHasFailed': 'danger',
        'App\\Notifications\\Statistic\\StatisticsGenerated': 'success',
        'App\\Notifications\\Statistic\\StatisticsFailedToBeGenerated': 'danger',
        default: 'info',
    },
} satisfies NotificationConfig;
